import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/config.js";

export async function getAllFaqs() {
    try {
        const querySnapshot = await getDocs(collection(db, "faq"));
        const allFaq = []
        querySnapshot.forEach((doc) => {
            allFaq.push({ id: doc.id, ...doc.data() })
        });
        return { success: true, faq: allFaq };
    } catch (error) {
        console.error('Error getting request:', error);
        return { success: false, error: error.message };
    }
}